<template>
  <v-app>
    <NavBar />
    <v-main>
      <router-view/>
    </v-main>
    <v-footer>
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar.vue'
import {defineComponent} from "vue";

export default defineComponent({
  name: 'App',
  components: {
    NavBar
  }
});
</script>
